import { render, staticRenderFns } from "./SendMessageReadFamiliesModal.vue?vue&type=template&id=1267f0fb&lang=pug"
import script from "./SendMessageReadFamiliesModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageReadFamiliesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports